import fetch from 'isomorphic-fetch';
import { handleAsyncError, parseJSON } from './utils';

/** @deprecated */
export default function apiMiddleware() {
  return (next) => (action) => {
    const { apicall, types, notifications, ...rest } = action;
    let NOTIFICATION_SUCCESS;
    let NOTIFICATION_FAILURE;

    if (!apicall) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;

    if (notifications) {
      [NOTIFICATION_SUCCESS, NOTIFICATION_FAILURE] = notifications;
    }

    if (REQUEST) next({ ...rest, type: REQUEST });

    const {
      endpoint = '/api',
      method = 'POST',
      headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body,
    } = apicall;

    return fetch(endpoint, {
      method,
      headers,
      body: body && JSON.stringify(apicall.body),
      credentials: 'same-origin',
    })
      .then(handleAsyncError)
      .then(parseJSON)
      .then((payload) => {
        if (notifications && NOTIFICATION_SUCCESS) {
          next({ ...rest, payload, type: NOTIFICATION_SUCCESS });
        }

        if (SUCCESS && typeof SUCCESS === 'string') {
          next({ ...rest, payload, type: SUCCESS });
        } else if (SUCCESS && typeof SUCCESS === 'function') {
          next(SUCCESS(payload, rest));
        }

        return Promise.resolve(payload);
      })
      .catch((error) => {
        if (notifications && NOTIFICATION_FAILURE) {
          next({ ...rest, error, type: NOTIFICATION_FAILURE });
        }

        if (FAILURE) {
          next({ ...rest, error, type: FAILURE });
        }

        return Promise.reject(error);
      });
  };
}
